module.exports = __webpack_public_path__ + "static/media/YF25_3.77116f25.jpg";